/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_difference_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentage Difference Calculator`)
};

const es_pct_difference_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Diferencia Porcentual`)
};

const de_pct_difference_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechner für prozentualen Unterschied`)
};

const nl_pct_difference_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentageverschil berekenen`)
};

const fr_pct_difference_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de différence en pourcentage`)
};

const it_pct_difference_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore di differenza percentuale`)
};

const pt_br2_pct_difference_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Diferença Percentual`)
};

const pt_pct_difference_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Diferença Percentual`)
};

const ja_pct_difference_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パーセントの差計算機`)
};

const zh_pct_difference_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`百分比差异计算器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_difference_h1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_difference_h1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_difference_h1", locale)
	if (locale === "en") return en_pct_difference_h1(inputs)
	if (locale === "es") return es_pct_difference_h1(inputs)
	if (locale === "de") return de_pct_difference_h1(inputs)
	if (locale === "nl") return nl_pct_difference_h1(inputs)
	if (locale === "fr") return fr_pct_difference_h1(inputs)
	if (locale === "it") return it_pct_difference_h1(inputs)
	if (locale === "pt-BR") return pt_br2_pct_difference_h1(inputs)
	if (locale === "pt") return pt_pct_difference_h1(inputs)
	if (locale === "ja") return ja_pct_difference_h1(inputs)
	return zh_pct_difference_h1(inputs)
};